module.exports = __webpack_public_path__ + "assets/projects/digital-data-collection/project-preview.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/digital-data-collection/project-preview.jpg
// module id = 10
// module chunks = 0